import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

const InjectMassage = props => <FormattedMessage  tagName='a' {...props} />
export default injectIntl(InjectMassage, {
    withRef: false,
})
